import React, { useState, useEffect } from 'react';
import './index.css';
import Header from './components/Header';
import Hero from './components/Hero';
import CustomerLogos from './components/CustomerLogos';
import Footer from './components/Footer';
import Privacy from './components/Privacy';
import WhyKeops from './components/WhyKeops';
import Services from './components/Services';
import ProductCoverage from './components/ProductCoverage';

// Route configuration
const routes = {
  '/': 'home',
  '/privacy': 'privacy',
  '/terms': 'privacy'
} as const;

type RouteKey = keyof typeof routes;
type PageType = typeof routes[RouteKey];

// Custom Router Component
const Router: React.FC<{ children: (page: PageType) => React.ReactNode }> = ({ children }) => {
  const [currentPath, setCurrentPath] = useState<string>(window.location.pathname);

  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Navigate function for programmatic navigation
  const navigate = (path: string) => {
    window.history.pushState({}, '', path);
    setCurrentPath(path);
  };

  // Make navigate available globally
  (window as any).navigate = navigate;

  const currentPage = routes[currentPath as RouteKey] || 'home';
  return <>{children(currentPage)}</>;
};

// Home page component
const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <CustomerLogos />
      <Services />
      <ProductCoverage />
      <WhyKeops />
      {/* <Contact /> */}
    </>
  );
};

// Route Components
const RouteComponents = {
  home: HomePage,
  privacy: Privacy
} as const;

function App() {
  return (
    <div className="App bg-gray-900 min-h-screen">
      <Header />
      <main>
        <Router>
          {(page) => {
            const Component = RouteComponents[page];
            return <Component />;
          }}
        </Router>
      </main>
      <Footer />
    </div>
  );
}

export default App;
